import * as Constants from "../common/Constants";
import cloneDeep from "lodash/cloneDeep";

const initialState = {
    accounts: [],
    account: null,
    isLoading: false,
    isPosting: false,
    isPosted: false,
    getAccount: false,
    error: null,
    contactAccounts: [],
    editableAccount: null,
    filteredAccounts: []
};


function _getAccount(accounts, id) {
    for (var i = 0; i < accounts.length; i++) {
        let acc = accounts[i];
        if (acc.id === id) {
            return acc;
        } else if (acc.childs) {
            var cAcc = _getAccount(acc.childs, id);
            if (cAcc) {
                return cAcc;
            }
        }
    }
}

export default function accountReducer(state = initialState, action) {
    var newState = { ...state };
    newState.getAccount = false;
    newState.isPosting = false;
    newState.isPosted = false;

    switch (action.type) {
        case Constants.REQUEST_ACCOUNT_HEAD:
        case Constants.REQUEST_FILTER_ACCOUNT_HEAD:
            newState.isLoading = true;
            return newState;

        case Constants.RECEIVE_SINGLE_ACCOUNT_HEAD:
            newState.isLoading = false;
            newState.editableAccount = action.payload;
            return newState;

        case Constants.RECEIVE_ACCOUNT_HEAD:
             
            newState.isLoading = false;
            if (action.allAccounts) {
                newState.allAccounts = [...action.allAccounts];
            } else if (action.account) {
                if (!action.marge) {
                    newState.getAccount = true;
                    newState.account = action.account;
                } else {
                    const accs = cloneDeep(newState.accounts);
                    const ac = _getAccount(accs, action.account.id);
                    ac.childs = action.account.childs;
                    newState.accounts = accs;
                }
            } else if (action.contactAccounts) {
                newState.contactAccounts = action.contactAccounts;
            }
            else {
                newState.accounts = action.accounts;
            }
            return newState;

        case Constants.RECEIVE_FILTER_ACCOUNT_HEAD:
            newState.isLoading = false;
            newState.filteredAccounts = action.payload;
            return newState;

        case Constants.FAILED_ACCOUNT_HEAD:
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_ADD_NEW_ACCOUNT_HEAD:
        case Constants.REQUEST_ADD_PAYMENT_ACCOUNT_HEAD:
            newState.isPosting = true;
            return newState;

        case Constants.SUCCESS_ADD_NEW_ACCOUNT_HEAD:
        case Constants.SUCCESS_ADD_PAYMENT_ACCOUNT_HEAD:
            newState.isPosting = false;
            newState.isPosted = true;
            //newState.accounts = [...newState.accounts].concat(action.account);
            newState.account = action.account;
            return newState;

        case Constants.FAILED_ADD_NEW_ACCOUNT_HEAD:
        case Constants.FAILED_ADD_PAYMENT_ACCOUNT_HEAD:
            newState.isPosting = false;
            newState.error = action.error;
            return newState;

        case Constants.RESET_EDITABLE_ACCOUNT_HEAD:
            newState.editableAccount = null;
            return newState;

        case Constants.RESET_ACCOUNT:
            newState.accounts = [];
            newState.account = null;
            newState.isLoading = false;
            newState.isPosting = false;
            newState.isPosted = false;
            newState.getAccount = false;
            newState.error = null;
            newState.contactAccounts = [];
            newState.editableAccount = null;
            newState.filteredAccounts = [];
            return newState;

        default:
            return newState;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/AccountReducer.js